import React from 'react';
import './TrashButton.css';

import DeleteIcon from './DeleteIcon';

interface TrashButtonProps {
  onClick: () => void;
}

const TrashButton: React.FC<TrashButtonProps> = ({ onClick }) => {
  return (
    <button
      type="button"
      className="trash-button"
      data-testid="trash-button"
      onClick={onClick}
    >
      <DeleteIcon />
    </button>
  );
};

export default TrashButton;
